import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose, branch, renderNothing } from 'recompose'
import { makeHasGate } from 'app/modules/gates/selectors'
import * as EndUserSelectors from 'app/modules/endUser/selectors'
import ActivitySection from './ActivitySection'
import ConversationSection from './ConversationSection'
import SalesforceSection from './SalesforceSection'
import LinkedinSection from './../LinkedinSection'
import HubSpotSection from './HubSpotSection'
import Profile from './Profile'
import CQLBar from './CQLBar'
import ScoringSection from './ScoringSection'
import EndUserAttributesCard from 'components/customer/EndUserAttributesCard'
import SegmentsCard from 'components/customer/SegmentsCard'
import { Sidebar, AboutCard, SegmentRow } from './style.styl'
import { isIntegrationConnected } from 'utils/Integrations'

class Person extends Component {
  render() {
    const {
      conversationId,
      endUser,
      hasMadKudu,
      hasSalesforce,
      hasLinkedin,
      hasHubSpot,
      ip,
    } = this.props

    return (
      <div className={Sidebar}>
        <Profile endUser={endUser} conversationId={conversationId}/>
        <CQLBar
          score={endUser ? endUser.getIn(['attributes', '_cql_score']) : undefined}
          endUserId={endUser ? endUser.id : undefined}
          conversationId={conversationId}
          isPlaceholder={!endUser}
        />
        {hasMadKudu && <ScoringSection endUser={endUser} />}
        {canDisplayLinkedinSectionContact(hasLinkedin, endUser) && <LinkedinSection endUser={endUser} />}
        {canDisplaySalesforceSection(hasSalesforce, endUser) && <SalesforceSection email={endUser.email} ip={ip}/>}
        {canDisplayHubSpotSection(hasHubSpot, endUser) && <HubSpotSection email={endUser.email}/>}
        <ConversationSection conversationId={conversationId}/>
        <ActivitySection
          key={endUser ? `activity-section-${endUser.id}` : undefined}
          endUserId={endUser ? endUser.id : undefined}
        />
        <EndUserAttributesCard className={AboutCard} hideAllAttributesModal endUser={endUser} />
        <SegmentsCard
          className={AboutCard}
          endUserId={endUser ? endUser.id : undefined}
          segmentClassName={SegmentRow}
        />
      </div>
    )
  }
}

const canDisplayLinkedinSectionContact = (hasLinkedin, endUser) => {
  return hasLinkedin && !!endUser
}

const canDisplaySalesforceSection = (hasSalesforce, endUser) => {
  return hasSalesforce && endUser
}

const canDisplayHubSpotSection = (hasHubSpot, endUser) => {
  return hasHubSpot && endUser && endUser.email
}

const makeMapStateToProps = () => {
  const endUserForConversationId = EndUserSelectors.makeEndUserForConversationIdSelector()
  const fetchEndUserForConversationIdFailed = EndUserSelectors.makeFetchEndUserForConversationIdFailedSelector()

  return (state, props) => {
    const { conversationId } = props

    return {
      endUser: endUserForConversationId(state, { conversationId }),
      endUserNotFound: fetchEndUserForConversationIdFailed(state, { conversationId }),
      hasMadKudu: makeHasGate('has_madkudu')(state),
      hasSalesforce: isIntegrationConnected('salesforce'),
      hasHubSpot: isIntegrationConnected('hubspot'),
      hasLinkedin: isIntegrationConnected('linkedin')
    }
  }
}

export default compose(
  connect(makeMapStateToProps),
  branch(props => props.endUserNotFound, renderNothing),
)(Person)



// WEBPACK FOOTER //
// ./src/scripts/components/conversation/ContactSideBar/Person/index.js